export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'LastName',
    'Email',
    'RequestMessage',
    'DataProtectionAgreement'
  ],
  'requiredFields': {
    'default': [
      'VATNumber',
      'Company',
      'PostalCode'
    ],
    'consulting': [
      'VATNumber',
      'RequestTopic',
      'Company',
      'PostalCode'
    ],
    'customer_serviceGeneral': [
      'VATNumber',
      'RequestTopic',
      'Company',
      'PostalCode'
    ],
    'cooperation': [
      'VATNumber',
      'RequestTopic',
      'Company',
      'PostalCode'
    ],
    'other': [
      'PostalCode'
    ]
  }
}
